import React, { useState, useEffect, useContext } from "react";
import Header from "../Header";
import Footer from "../Footer";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import greenTick from "../../../../assets/Group 9204.svg";
import greyTick from "../../../../assets/Group 9205.svg";
import { Link } from "react-router-dom";
import axios from "../../../../libs/axios";
import "./SignUp.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { provider, auth } from "../../../../firebase.js";
import { signInWithPopup } from "firebase/auth";
import { useAuth } from "../../../context/auth.js";
import { UserDispatchContext, useUpgradeModal } from "../../../context/user.js";
import { getDaysDiff } from "../../../../libs/utility.js";
import CircularProgress from "@mui/material/CircularProgress";
import googleIcon from "../../../../assets/google.svg";

const passwordValidations = [
  {
    label: "8 characters least",
    check: (password) => password.length >= 8,
  },
  {
    label: "Contains one alphabet",
    check: (password) => /[a-zA-Z]/.test(password),
  },
  {
    label: "Contains uppercase",
    check: (password) => /[A-Z]/.test(password),
  },
  {
    label: "Contains number",
    check: (password) => /\d/.test(password),
  },
  {
    label: "Contains lowercase",
    check: (password) => /[a-z]/.test(password),
  },
  {
    label: "Special characters",
    check: (password) => /[!@#$%^&*(),.?":{}|<>]/.test(password),
  },
];

const SignUp = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [allValidationsPassed, setAllValidationsPassed] = useState(false);
  const [fullName, setFullName] = useState();
  const [email, setEmail] = useState();
  const [showOtpBtn, setShowOtpBtn] = useState(true);
  const [showOtpField, setShowOtpField] = useState(false);
  const [sentOtp, setSentOtp] = useState(null);
  const [otp, setOtp] = useState(null);
  const [otpVerify, setOtpVerify] = useState(false);
  const [loading, setLoading] = useState(false);
  const [signUpLoading, setSignUpLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false); // Add resend loading state
  const [timer, setTimer] = useState(30);
  const [showResendButton, setShowResendButton] = useState(false); // Changed to false initially

  const { setIsAuthenticated } = useAuth();
  const { setshowupgrade } = useUpgradeModal();
  const setUser = useContext(UserDispatchContext);

  const startCountdown = (setTimer, setShowResendButton) => {
    const countdown = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) {
          clearInterval(countdown);
          setShowResendButton(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handlePasswordChange = (event) => {
    const newPassword = event.target.value;
    setPassword(newPassword);
  };

  useEffect(() => {
    const allValid = passwordValidations.every((validation) =>
      validation.check(password)
    );
    setAllValidationsPassed(allValid);
  }, [password]);

  const getUser = (isLoggedIn) => {
    if (isLoggedIn) {
      axios.get("/api/user").then((res) => {
        if (res.status === 200) {
          if (res.data.data) {
            setUser(res.data.data);
            const daysDiff = getDaysDiff(
              new Date(res.data.data?.createdAt),
              new Date()
            );
            const daysLeft = 15 - daysDiff;

            daysLeft > 0 && res.data.data?.subscription == null
              ? console.log(`${daysLeft} days free trial left`)
              : res.data.data?.subscription == null
                ? setshowupgrade(true)
                : new Date(res.data.data?.subscription.endDate) >= new Date()
                  ? console.log("Subscribed")
                  : console.log("Subscription Expired");
          }
        }
      });
    }
  };

  const loginCalling = async (data) => {
    try {
      const loginUserURL = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/newauth/login`;
      const body = {
        email: data?.data?.email,
        password: password,
      };

      try {
        const { data: loginData } = await axios.post(loginUserURL, body);
        if (loginData?.success) {
          getUser(true);
          if (loginData.signInData.token) {
            setIsAuthenticated(true);
          }
          localStorage.setItem("token", loginData.signInData?.token);
          localStorage.setItem("userEmail", loginData.signInData?.email);
          localStorage.setItem("emailVerified", loginData.signInData?.emailVerified);
          localStorage.setItem("expiresIn", loginData.signInData?.expiresIn);
          localStorage.setItem("isAnonymous", loginData.signInData?.isAnonymous);
          localStorage.setItem("operationType", loginData.signInData?.operationType);
          localStorage.setItem("refreshToken", loginData.signInData?.refreshToken);
          localStorage.setItem("registered", loginData.signInData?.registered);

          navigate("/afterLogin");
        }
      } catch (error) {
        console.error("Error during login request:", error);
        toast.error("Login failed");
      } finally {
        setSignUpLoading(false);
      }
    } catch (error) {
      toast.error(error);
      setSignUpLoading(false);
    }
  };

  const handleNextClick = async () => {
    if (allValidationsPassed && fullName && email && otpVerify === true) {
      try {
        setSignUpLoading(true);
        const registeredUserURL = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/newauth/init`;
        const body = { email, fullname: fullName, password };

        const { data } = await axios.post(registeredUserURL, body);

        if (data?.success) {
          loginCalling(data);
        } else {
          toast.error(data.message);
          setSignUpLoading(false);
        }
      } catch (error) {
        toast.error(error);
        setSignUpLoading(false);
      }
    } else {
      toast.warning("Unverified email. Please complete OTP verification.");
    }
  };

  const handleEmailInput = (e) => {
    const regex = /^[a-zA-Z0-9@._-]*$/;
    e.target.value = e.target.value.replace(/^\s+/g, "").match(regex)
      ? e.target.value
      : email;
  };

  const handleOtpSend = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post("/api/auth/init", {
        withCredentials: true,
        email,
      });

      if (res.status === 200) {
        setSentOtp(true);
        setLoading(false);
        setTimer(30);
        setShowResendButton(false);
        toast.success("OTP sent");
        setOtpVerify(false);
        setShowOtpField(true);
        setShowOtpBtn(false);
        startCountdown(setTimer, setShowResendButton);
        return true;
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "OTP sending failed");
      setSentOtp(false);
      setLoading(false);
      setShowOtpField(false);
      return false;
    }
  };

  const handleResendOtp = async (e) => {
    e.preventDefault();
    
    // Prevent multiple clicks
    if (resendLoading) return;
    
    setResendLoading(true);

    try {
      const response = await axios.post("/api/auth/resend", { email });

      if (response.status === 200) {
        toast.success("OTP resent");
        setShowResendButton(false);
        setTimer(30);
        startCountdown(setTimer, setShowResendButton);
        return response.data;
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to resend OTP");
      return false;
    } finally {
      setResendLoading(false);
    }
  };

  const name = document.getElementById("fullName");
  const passwordField = document.getElementById("password");

  const otpVerifyHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    name.removeAttribute("required");
    passwordField.removeAttribute("required");

    try {
      if (email && otp && sentOtp) {
        const res = await axios.post("/api/auth/verify", {
          email,
          otp,
          flag: "signup",
        });
        if (res.status === 200) {
          setOtpVerify(true);
          setOtp(null);
          setLoading(false);
          setShowOtpField(false);
          toast.success("Authenticated Successfully!");
          return true;
        } else {
          toast.error("Authentication failed");
          setLoading(false);
          setShowOtpField(true);
          return false;
        }
      }
    } catch (error) {
      toast.error("Something went wrong");
      setLoading(false);
      return false;
    }
  };

  const loginWithGoogle = async () => {
    try {
      const googleLoginData = await signInWithPopup(auth, provider);
      if (googleLoginData.user) {
        const loginUserURL = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/newauth/login/google`;

        const body = {
          email: googleLoginData?.user?.email,
          uid: googleLoginData?.user?.uid,
          accessToken: googleLoginData?.user?.accessToken,
          userData: googleLoginData?.user?.reloadUserInfo,
          fullname: googleLoginData?.user?.displayName,
        };

        try {
          const { data } = await axios.post(loginUserURL, body);
          if (data?.success) {
            getUser(true);
            if (data.signInData.token) {
              setIsAuthenticated(true);
            }
            localStorage.setItem("token", data.signInData?.token);
            localStorage.setItem("userEmail", googleLoginData?.user?.email);
            localStorage.setItem(
              "emailVerified",
              googleLoginData?.user?.emailVerified
            );
            localStorage.setItem(
              "isAnonymous",
              googleLoginData?.user?.isAnonymous
            );
            localStorage.setItem(
              "operationType",
              data.signInData?.operationType
            );
            navigate("/afterLogin");
          }
        } catch (error) {
          console.error("Error during login request:", error);
        }
      }
    } catch (err) {
      console.log("Error", err);
    }
  };

  return (
    <>
      <Header />
      <div className="sign-up-container">
        <form className="sign-up-form">
          <div className="sign-up-header" onClick={loginWithGoogle}>
            Start your free Oyster trial
          </div>
          <button
            type="button"
            className="login-with-google-btn"
            onClick={loginWithGoogle}
          >
            <img
              src={googleIcon}
              alt="Google"
              className="google-icon"
            />
            <span>SIGN UP WITH GOOGLE</span>
          </button>
          <div className="or">-OR-</div>

          <div className="form-label">
            <InputLabel
              sx={{
                color: "#7C838A",
                fontFamily: "Poppins",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "500",
              }}
              htmlFor="fullName"
            >
              Full Name
            </InputLabel>
            <TextField
              sx={{
                width: "100%",
                height: "100%",
                background: "rgba(176, 186, 195, 0.40)",
                borderRadius: "7px",
              }}
              id="fullName"
              fullWidth
              margin="normal"
              required
              className="other-field"
              placeholder="Enter your Full Name here"
              onChange={(e) => setFullName(e.target.value)}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^a-zA-Z\s]/g, "")
                  .replace(/^\s+/g, "");
              }}
            />
          </div>

          <div className="form-label">
            <InputLabel
              sx={{
                color: "#7C838A",
                marginBottom: "8px",
                fontFamily: "Poppins",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "500",
              }}
              htmlFor="workEmail"
            >
              Work Email
            </InputLabel>
            <div className="flex gap-3 justify-between">
              <div className={`${showOtpBtn == false ? "w-full" : "w-full"}`}>
                <TextField
                  sx={{
                    width: "100%",
                    height: "100%",
                    margin: 0,
                    background: "rgba(176, 186, 195, 0.40)",
                    borderRadius: "8px",
                  }}
                  type="email"
                  className="other-field"
                  id="workEmail"
                  fullWidth
                  margin="normal"
                  required
                  placeholder="Enter your Email here"
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setShowOtpBtn(true);
                    setOtpVerify(false);
                    setSentOtp(false);
                    setShowOtpField(false);
                    setOtp(null);
                  }}
                />
              </div>
              {showOtpBtn === true ? (
                <div
                  className="w-[200px] flex items-center justify-center"
                  style={{
                    backgroundColor: "#3B82F6",
                    borderRadius: "10px",
                  }}
                >
                  {loading ? (
                    <CircularProgress
                      size={20}
                      sx={{
                        color: "#ffffff",
                      }}
                    />
                  ) : (
                    <button
                      className="text-white h-full px-2"
                      onClick={handleOtpSend}
                      style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: '500',
                        fontSize: '15px'
                      }}
                      type="button"
                    >
                      Send OTP
                    </button>
                  )}
                </div>
              ) : null}
            </div>
          </div>

          {showOtpField === true ? (
            <div className="flex pb-3 pt-1 gap-2 w-full justify-between">
              <input
                type="text"
                className="otp w-full outline-none border rounded-xl border-[#e5e7eb] h-full px-3 py-2"
                placeholder="Enter OTP"
                onChange={(e) => {
                  setOtp(e.target.value);
                }}
              />
              <div className="flex w-[200px] gap-2">
                <div
                  className="flex items-center justify-center"
                  style={{
                    backgroundColor: "#3B82F6",
                    borderRadius: "8px",
                    width: "50%",
                    color: "white",
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                >
                  {!showResendButton ? (
                    <span>
                      Wait {timer}s
                    </span>
                  ) : (
                    <button
                      className="h-full w-full text-white"
                      onClick={handleResendOtp}
                      disabled={resendLoading}
                      type="button"
                    >
                      {resendLoading ? (
                        <CircularProgress size={16} sx={{ color: "#ffffff" }} />
                      ) : (
                        "Resend"
                      )}
                    </button>
                  )}
                </div>
                
                <div
                  className="flex items-center justify-center"
                  style={{
                    backgroundColor: "#3B82F6",
                    borderRadius: "8px",
                    width: "50%",
                  }}
                >
                  {loading ? (
                    <CircularProgress
                      size={20}
                      sx={{
                        color: "#ffffff",
                      }}
                    />
                  ) : (
                    <button
                      className="text-white h-full w-full"
                      onClick={otpVerifyHandler}
                      disabled={!otp}
                      type="button"
                      style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: '500',
                        fontSize: '14px'
                      }}
                    >
                      Verify
                    </button>
                  )}
                </div>
              </div>
            </div>
          ) : null}

          <div className="form-label">
            <InputLabel
              sx={{
                color: "#7C838A",
                fontFamily: "Poppins",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "500",
              }}
              htmlFor="password"
            >
              Password
            </InputLabel>
            <TextField
              sx={{
                width: "100%",
                height: "100%",
                background: "rgba(176, 186, 195, 0.40)",
                borderRadius: "8px",
                color: "rgba(0, 0, 0, 0.50)",
                fontSize: 20,
                fontFamily: "Poppins",
                fontWeight: "400",
              }}
              id="password"
              type="password"
              fullWidth
              margin="normal"
              required
              placeholder="Create your Password here"
              onChange={handlePasswordChange}
            />
            <div className="password-validations">
              {passwordValidations.map((validation, index) => (
                <div key={index} className="validation-item">
                  {validation.check(password) ? (
                    <img src={greenTick} alt="" />
                  ) : (
                    <img src={greyTick} alt="" />
                  )}
                  <span>{validation.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div>
            <Button
              sx={{
                width: "100%",
                background: "#6B6B6B",
                borderRadius: "8px",
                color: "white",
                fontSize: 20,
                fontFamily: "Poppins",
                fontWeight: "400",
              }}
              variant="contained"
              color="primary"
              className="Next-button"
              onClick={handleNextClick}
              disabled={!allValidationsPassed || signUpLoading}
            >
              {signUpLoading ? (
                <CircularProgress size={24} sx={{ color: "#ffffff" }} />
              ) : (
                "Sign Up"
              )}
            </Button>
          </div>
          
          <div className="login-section">
            <span className="login-text">Already a Member? </span>
            <Link to="/auth" className="login-link">
              LOG IN
            </Link>
          </div>
        </form>
      </div>

      <Footer />
    </>
  );
};

export default SignUp;